import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, Loader2, CheckCircle2 } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { API, errMsg } from "@/lib/api";
import { COMPANY, LOGO } from "@/lib/constants";
import axios from "axios";

const Stars = ({ value, onChange, testId }) => (
  <div className="flex gap-1 justify-center" dir="ltr" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n}`} data-testid={`${testId}-${n}`} className="p-1 transition-transform hover:scale-110">
        <Star size={38} className={n <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
      </button>
    ))}
  </div>
);

export default function RateVisit() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [agent, setAgent] = useState(0);
  const [visit, setVisit] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/ratings/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e)));
  }, [token]);

  const submit = async () => {
    if (!agent || !visit) return setError("اختر عدد النجوم للمندوب وللزيارة");
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/public/ratings/${token}`, { agent, visit, comment });
      setDone(true);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const thanks = done || info?.rated;
  return (
    <div className="min-h-screen bg-brand-mist flex items-center justify-center p-4" data-testid="rate-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-xl overflow-hidden">
        <div className="h-1.5 bg-brand-red" /><div className="h-1 bg-brand-navy" />
        <div className="p-6 space-y-5 text-center">
          <img src={LOGO} alt={COMPANY} className="h-20 w-20 mx-auto rounded-full object-contain" />
          <p className="font-heading font-extrabold text-xl text-brand-navy">{COMPANY}</p>
          {!info && !error && <Loader2 className="animate-spin mx-auto text-brand-red" />}
          {!info && error && <p className="text-red-600" data-testid="rate-error">{error}</p>}
          {info && thanks && (
            <div className="space-y-2 py-6" data-testid="rate-thanks">
              <CheckCircle2 size={48} className="mx-auto text-emerald-600" />
              <p className="font-heading font-bold text-lg">شكراً لتقييمك!</p>
              <p className="text-sm text-slate-500">رأيك يساعدنا على تحسين خدمتنا.</p>
            </div>
          )}
          {info && !thanks && (
            <>
              <p className="text-slate-600 text-sm">أهلاً {info.customer_name}، نسعد بتقييمك لزيارة المعاينة رقم <span className="font-mono">{info.ref}</span></p>
              <div className="space-y-1"><p className="font-bold">تقييم المندوب: {info.agent_name}</p><Stars value={agent} onChange={(v) => { setAgent(v); setError(""); }} testId="rate-agent" /></div>
              <div className="space-y-1"><p className="font-bold">جودة الزيارة والالتزام بالموعد</p><Stars value={visit} onChange={(v) => { setVisit(v); setError(""); }} testId="rate-visit" /></div>
              <Textarea value={comment} onChange={(e) => setComment(e.target.value.slice(0, 500))} placeholder="ملاحظاتك (اختياري)" data-testid="rate-comment" />
              {error && <p className="text-sm text-red-600" data-testid="rate-error">{error}</p>}
              <button onClick={submit} disabled={busy} data-testid="rate-submit" className="w-full h-12 rounded-lg bg-brand-red text-white font-bold hover:bg-brand-red-dark flex items-center justify-center gap-2 disabled:opacity-60">
                {busy && <Loader2 size={18} className="animate-spin" />}إرسال التقييم
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
